import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { type RestModalPerson } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';

type Props = {
  person: RestModalPerson;
  horizontal?: boolean;
  horizontalSB?: boolean;
};

const ModalPerson: React.FC<Props> = (props) => {
  const {
    person: { title, organization, preposition, avatar, name },
    horizontal,
    horizontalSB,
  } = props;

  const personIconStyle = {
    width: '75px',
    height: '75px',
    padding: '15px',
    backgroundColor: '#ccc',
    fill: '#fff',
    borderRadius: '50%',
  };

  return (
    <div
      className={cs('modal-person', {
        'horizontal-layout': horizontal,
        'horizontal-layout horizontal-layout-sb': horizontalSB,
      })}
    >
      <div className="MPContainer">
        <div className="avatar">
          {avatar ? (
            <img src={avatar} alt="" />
          ) : (
            <PersonIcon style={personIconStyle} />
          )}
        </div>
        <div className="info">
          <div className="name">{name}</div>
          <div className="position">
            {title} {preposition}{' '}
            <span className="organization">{organization}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPerson;
